import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { GroupsTypes, GroupInterface } from './types';

// List Groups
export const listGroupsRequest = (payload: {
  body: object;
  filtering?: boolean;
}) => action(GroupsTypes.LIST_GROUPS_REQUEST, payload);
export const listGroupsSuccess = (payload: {
  groupsList: GroupInterface[];
  totalCount: number;
}) => action(GroupsTypes.LIST_GROUPS_SUCCESS, payload);
export const listGroupsFailure = () => action(GroupsTypes.LIST_GROUPS_FAILURE);

// Get Group
export const getGroupRequest = (payload: object) =>
  action(GroupsTypes.GET_GROUP_REQUEST, payload);
export const getGroupSuccess = (payload: { groupData: GroupInterface }) =>
  action(GroupsTypes.GET_GROUP_SUCCESS, payload);
export const getGroupFailure = () => action(GroupsTypes.GET_GROUP_FAILURE);

// Filter Groups
export const filterGroupsRequest = (payload: object) =>
  action(GroupsTypes.FILTER_GROUPS_REQUEST, payload);
export const filterGroupsSuccess = (payload: {
  groupsList: GroupInterface[];
  totalCount: number;
}) => action(GroupsTypes.FILTER_GROUPS_SUCCESS, payload);
export const filterGroupsFailure = () =>
  action(GroupsTypes.FILTER_GROUPS_FAILURE);

// Create Group
export const createGroupRequest = (payload: object) =>
  action(GroupsTypes.CREATE_GROUP_REQUEST, payload);
export const createGroupSuccess = (payload: { groupData: GroupInterface }) =>
  action(GroupsTypes.CREATE_GROUP_SUCCESS, payload);
export const createGroupFailure = () =>
  action(GroupsTypes.CREATE_GROUP_FAILURE);

// Update Group
export const updateGroupRequest = (payload: object) =>
  action(GroupsTypes.UPDATE_GROUP_REQUEST, payload);
export const updateGroupSuccess = (payload: { groupData: GroupInterface }) =>
  action(GroupsTypes.UPDATE_GROUP_SUCCESS, payload);
export const updateGroupFailure = () =>
  action(GroupsTypes.UPDATE_GROUP_FAILURE);

// Delete Group
export const deleteGroupRequest = (payload: object) =>
  action(GroupsTypes.DELETE_GROUP_REQUEST, payload);
export const deleteGroupSuccess = () =>
  action(GroupsTypes.DELETE_GROUP_SUCCESS);
export const deleteGroupFailure = () =>
  action(GroupsTypes.DELETE_GROUP_FAILURE);
